import PropTypes from 'prop-types';
import React from 'react';
import SendNotifications from './sendNotifications';
import Header from '../header';
import Icon, { GLYPHS } from '../../../../common/icon';
import { t } from '../../../../../modules/infra/i18n';

const CancelConfirmationScreen = (props) => {
  const {
    cancel,
    hideConfirmationScreen,
    toggleNotifications,
    sendNotifications,
    message,
  } = props;

  // TODO: rewrite it
  const modalWrapper = document.getElementsByClassName('remodal-wrapper');
  if (modalWrapper.length) {
    modalWrapper[0].scrollTop = 0;
  }

  return (
    <div className="c-appointment-confirmation u-text-left">
      <Header onClose={hideConfirmationScreen} />
      <div className="layout__item u-pr">
        <p>{message}</p>
      </div>
      <SendNotifications
        checked={sendNotifications}
        onChange={toggleNotifications}
      />
      <div className="c-appointment-form__controls u-text-right u-ph- u-pb-">
        <div className="c-separator u-mb- u-mt" />
        <a
          className="c-btn c-btn--outline c-btn--outline-grey u-float-left"
          onClick={hideConfirmationScreen}
        >
          <Icon glyph={GLYPHS.refresh} size="medium" />
          <span className="c-btn__text">{t('appointment:confirmation.back_button')}</span>
        </a>
        <button
          className="c-btn c-btn--grey u-ph-"
          type="button"
          onClick={cancel}
        >
          <span className="c-btn__text">{t('appointment:actions.cancel_appointment')}</span>
        </button>
      </div>
    </div>
  );
};

CancelConfirmationScreen.propTypes = {
  cancel: PropTypes.func.isRequired,
  hideConfirmationScreen: PropTypes.func.isRequired,
  toggleNotifications: PropTypes.func.isRequired,
  sendNotifications: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default CancelConfirmationScreen;
